import * as Yup from 'yup'

export const EVoucherRedemptionTxSchemas = Yup.object().shape({
  creditValue: Yup.number(),
  externalTransactionId: Yup.number().optional().nullable(),
  ident: Yup.string(),
  storeId: Yup.number(),
  tenderDetail: Yup.array().of(
    Yup.object().shape({
      tenderIdentifier: Yup.string(),
      tenderTypeId: Yup.number(),
    })
  ),
  transactionDate: Yup.string(),
  deviceCode: Yup.string(),
  tenderValue: Yup.number(),
})
